import {Box, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

const levelStyles: BetterSystemStyleObject = {
  width: '16px',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  '&::before': {
    content: "''",
    display: 'block',
    width: '8px',
    borderLeft: '1px solid',
    borderColor: 'border.subtle',
  },
}

/** Lines to indicate the depth of an item in a TreeView */
export function LevelIndicatorLines({levels, isExpanded = false}: {levels: boolean[]; isExpanded?: boolean}) {
  return (
    <>
      {levels.map((isLast, index) => (
        <Box
          key={index}
          sx={merge<BetterSystemStyleObject>(levelStyles, {
            position: isExpanded ? 'absolute' : 'unset',
            height: isExpanded ? '39px' : '38px',
            paddingTop: isExpanded ? '28px' : '0px',
            paddingBottom: isExpanded ? '0px' : '0px',
            '&::before': {
              height: isLast ? '40%' : '100%',
              borderBottomLeftRadius: isLast ? 3 : 0,
            },
          })}
        />
      ))}
    </>
  )
}

try{ LevelIndicatorLines.displayName ||= 'LevelIndicatorLines' } catch {}